import Icon from '../components/Icon.vue'

Icon.register({"plus":{"width":448,"height":512,"paths":[{"d":"M448 294.2V217.8C448 204.5 437.3 193.8 424 193.8H286.2V56C286.2 42.7 275.5 32 262.2 32H185.8C172.5 32 161.8 42.7 161.8 56V193.8H24C10.7 193.8 0 204.5 0 217.8V294.2C0 307.5 10.7 318.2 24 318.2H161.8V456C161.8 469.3 172.5 480 185.8 480H262.2C275.5 480 286.2 469.3 286.2 456V318.2H424C437.3 318.2 448 307.5 448 294.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/plus.js
// module id = null
// module chunks = 